import * as React from 'react';
import type {SystemQuote, SystemSpec} from '@/types';
import {
  DialogFooter,
} from "@/components/atoms/dialog"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import {Button} from '@/components/atoms/button.tsx';
import {ShowAsDollars} from '@/components/atoms/ShowNumberAsDollars';
import { cn } from "@/lib/utils"
export type ViewSystemProps = {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  system: SystemQuote | null
}

const getComponentName = (spec: SystemSpec): string => {
  if(spec.category && spec.category.name) {
    return spec.category.name;
  }
  return '';
}

export function ViewSystem(props: ViewSystemProps) {
  if(!props.system) {
    return null;
  }
  const handleClose = () => {
    props.onOpenChange(false);
  }
  return (
    <DialogPrimitive.Root open={props.isOpen} onOpenChange={props.onOpenChange}>
      <DialogPrimitive.DialogPortal {...props} data-slot="dialog-portal">
        <DialogPrimitive.Overlay
          className={cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50")} />
        <DialogPrimitive.Content {...props} 
          className={cn("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full translate-x-[-50%] translate-y-[-50%] duration-200 sm:max-w-lg max-w-none w-screen h-dvh scroll-smooth")}
        >
          <h3 className="text-2xl p-4 font-bold">{props.system.name}</h3>
          <div className="grid p-4 overflow-y-auto">
              {
                props.system.specs.map(spec => (
                  <div key={spec._id} className="flex py-4 flex-row flex-wrap justify-between bb">
                    <div className="basis-full">
                      <div className="text-sm text-muted-foreground">{getComponentName(spec)}</div>
                    </div>
                    <div className="basis-9/10">
                      <div>{spec.product.manufacturer.name} {spec.product.description}</div>
                    </div>
                    <div className="basis-1/10 text-right">
                      <div className="text-sm text-muted-foreground">{spec.qty}</div>
                    </div>
                  </div>
                ))
              }
          </div>
          <DialogFooter>
            <div className="flex flex-row flex-wrap justify-between p-4">
              <div className="basis-1/2 text-lg font-bold">
                UNIT TOTAL
              </div>
              <div className="basis-1/2 text-lg font-bold text-right">
                <ShowAsDollars number={props.system.systemTotal} />
              </div>
              <div className="basis-1/2">
                QTY
              </div>
              <div className="basis-1/2 text-right">
                { props.system.qty}
              </div>
              <div className="basis-1/2 text-lg font-bold">
                GRAND TOTAL
              </div>
              <div className="basis-1/2 text-lg font-bold text-right">
                <ShowAsDollars number={props.system.quoteTotal} />
              </div>
              <div className="basis-1/2 text-muted-foreground">
                GST Included
              </div>
              <div className="basis-1/2 text-muted-foreground text-right">
                ${props.system.gst.toFixed(2)}
              </div>
            <Button className="w-full mt-2" onClick={handleClose}>Close</Button>
            </div>
          </DialogFooter>
        </DialogPrimitive.Content>
      </DialogPrimitive.DialogPortal>
    </DialogPrimitive.Root>
  )
}
